import { defineComponent as _defineComponent } from 'vue'
import { DdPage } from "@/CodegenTypes";
import { mutations, queries } from "@/apollo";
import { customMoment, vueApp } from "@/main";
import { errorMutationNotification } from "@/utils";
import DdEntryTables from "./DdEntryTables.vue";
import { computed, ref, watch } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { apolloClient } from "@/apollo";
import DdPageMeta from "./DdPageMeta.vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageDetailsModal',
  props: {
    pageId: null,
    value: { type: Boolean },
    releaseDates: null,
    showDelete: { type: Boolean }
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pageId: DdPage["id"];
  value: boolean;
  releaseDates?: Date[];
  showDelete?: boolean;
};



const { $t } = useTranslation();


const {
  result: pageResult,
  loading,
  refetch,
} = useQuery<{ page: DdPage }>(queries.page, {
  id: computed(() => props.pageId),
  releaseDates: computed(() => props.releaseDates),
});

const page = computed(() => pageResult.value?.page);

const checkedEntries = ref<DdPage["id"][]>([]);



function formatDate(dateStr: string) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY hh:mm:ssA");
}

function toggleModal(val: boolean) {
  emit("input", val);
}

watch(
  () => props.value,
  (val) => {
    if (val) {
      checkedEntries.value = [];
    }
  }
);

function updateCheckedEntries(val: DdPage["id"][]) {
  console.log({ val });
  checkedEntries.value = val;
}

async function handleDelete() {
  vueApp.$confirm.require({
    header: 'Delete entry?',
    message: 'This action cannot be undone.',
    icon: 'pi pi-exclamation-triangle',
    accept: async () => {
      try {
        await apolloClient.mutate({
          mutation: mutations.deleteDdPageEntries,
          variables: {
            id: props.pageId,
            releaseDates: props.releaseDates,
            entryIds: checkedEntries.value,
          },
        });
        refetch();

        vueApp.$toast.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Entries deleted',
          life: 3000
        });
        checkedEntries.value = [];
        emit("submit");
      } catch (err) {
        errorMutationNotification(err);
      }
    },
    reject: () => {
      // Optional: Handle rejection
    }
  });
}


return { __sfc: true,props, $t, pageResult, loading, refetch, page, checkedEntries, emit, formatDate, toggleModal, updateCheckedEntries, handleDelete, DdEntryTables, DdPageMeta }
}

})